import { Typography } from 'seagull';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MondaySteps = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Typography, {
    children: "2. Click Integrate on your monday.com board"
  }), /*#__PURE__*/_jsx(Typography, {
    children: "3. Search Anchor and select an automation recipe"
  }), /*#__PURE__*/_jsx(Typography, {
    children: "4. When prompted, paste your API key into the Anchor API Key field"
  })]
});